import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  totals: {
    display: 'grid',
    // Two cards side by side, stacking below sm. Not a fixed 2-column grid: the in-flight
    // card must sit BESIDE applied on a wide screen so the two are comparable, and BELOW it
    // on a narrow one rather than being squeezed to unreadable.
    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3)
  },
  card: {
    background: theme.palette.grey[200],
    borderRadius: 8,
    padding: theme.spacing(2)
  },
  label: {
    color: theme.palette.text.secondary
  },
  count: {
    fontWeight: 700,
    marginTop: 4
  },
  money: {
    color: theme.palette.text.primary,
    marginTop: 4
  },
  caption: {
    display: 'block',
    color: theme.palette.text.secondary
  },
  empty: {
    color: theme.palette.text.disabled,
    marginTop: 4
  }
}))

export default useStyles
